/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IBootstrapFeature,
  IBootstrapFeatureInterface,
} from "../IBootstrapFeature";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
    ],
    name: "bootstrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IBootstrapFeature__factory {
  static readonly abi = _abi;
  static createInterface(): IBootstrapFeatureInterface {
    return new utils.Interface(_abi) as IBootstrapFeatureInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IBootstrapFeature {
    return new Contract(address, _abi, signerOrProvider) as IBootstrapFeature;
  }
}
